/** Shared helpers for match widget UI. */

export function parseScorePair(score) {
  if (!score || typeof score !== 'string') return { home: null, away: null };
  const m = String(score).match(/(\d+)\s*[–\-:]\s*(\d+)/);
  if (m) return { home: m[1], away: m[2] };
  return { home: null, away: null };
}

export function matchStatusConfig(match = {}) {
  const status = match.status || (match.live ? 'live' : match.upcoming ? 'upcoming' : 'finished');
  if (status === 'live' || match.live) {
    return {
      key: 'live',
      label: 'LIVE',
      pulse: true,
      className: 'sw-status-live',
    };
  }
  if (status === 'upcoming' || match.upcoming) {
    return {
      key: 'upcoming',
      label: 'UPCOMING',
      pulse: false,
      className: 'sw-status-upcoming',
    };
  }
  return {
    key: 'finished',
    label: 'FULL TIME',
    pulse: false,
    className: 'sw-status-ft',
  };
}

export function teamSideName(match, side) {
  return side === 'away' ? match?.away : match?.home;
}

export function splitGoalsByTeam(goals = [], match = {}) {
  const home = [];
  const away = [];
  for (const g of goals) {
    if (g.team === 'away') away.push(g);
    else home.push(g);
  }
  return { home, away, homeName: match.home, awayName: match.away };
}
